import React from 'react';
import Helmet from 'react-helmet';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import SheetTitle from '../../../components/SheetTitle';
import BackButton from '../../../components/BackButton';

import c from '../Help.less';

export default function () {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/cannot-topup-balance" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="I cannot top up my balance" />
      <p>
        If you have problems topping up your balance, please contact us.
      </p>
      <HelpContactUs subject={1} />
    </div>
  );
}
